(function () {
  angular
    .module("akitabox.planView.dialogs.printFloorPlan")
    .service("PrintFloorPlanDialog", PrintFloorPlanDialog);

  /* @ngInject */
  function PrintFloorPlanDialog($mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/desktop/modules/plan-view/dialogs/print-floor-plan/print-floor-plan.dialog.html",
      controller: "PrintFloorPlanDialogController",
      controllerAs: "vm",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: true,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    /**
     * AlertDialog service
     *
     * @type {Object}
     */
    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog
     *
     * @param  {Object}   options                    Dialog options
     * @param  {Object}   options.locals             Dialog options locals
     * @param  {String}   options.locals.print       Function to invoke with selected print option
     *
     * @return {Promise<Object|Error} Alert dialog promise
     */
    function show(options) {
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
